import { SelectField, SelectFieldProps } from '@ff-it/form';
import { displayTypeOptions, OOHDisplayType } from './types';
import type { Option } from 'options';

export function OOHDisplayTypeField(
  props: Omit<
    SelectFieldProps<Option<OOHDisplayType>, boolean>,
    'options' | 'loadOptions' | 'getOptionLabel' | 'getOptionValue' | 'simple'
  >,
) {
  return <SelectField options={displayTypeOptions} {...props} simple />;
}
